import client from './client'

export const pageViewDetails = ({ pageType, params: { userUniqueId, entityId } }) => {
	switch (pageType) {
		case 'product':
			try {
				client.post('product', {
					product: entityId,
					visitor: userUniqueId,
				})
			} catch (e) {
				console.error(e)
			}
			break

		default:
			break
	}
}
